import React from 'react';
import PropTypes from 'prop-types';
import IconDone from '@material-ui/icons/Done';
import IconRemove from '@material-ui/icons/Remove';
import { Tooltip } from '@material-ui/core';
import IconMore from '@material-ui/icons/MoreHoriz';
import { compareSqlAndSybase } from '../../../utils/normalizeTypes';

const iconDone = <IconDone fontSize="small" />;
const iconRemove = <IconRemove fontSize="small" />;
const iconMore = <IconMore fontSize="small" />;
const style = { textAlign: 'center' };

const CellBoolean = (props) => {
    const { titleTrue, titleFalse, value, codes } = props;

    const icon = React.useMemo(() => {
        // Jei lentelė jau pasakė, kad sutampa (value === true)
        if (value) return iconDone;

        // Jei turime kodus, tikriname statusą
        if (codes && codes.mysqlCode) {
            const status = compareSqlAndSybase(codes.mysqlCode, codes.sybaseCode);

            if (status === 2) return iconMore; // tik dėl tipų
            return iconRemove; // tikrai nesutampa
        }

        return iconRemove;
    }, [codes, value]);

    const title =
        icon === iconMore
            ? 'Nesutampa tik dėl duomenų tipų aprašymo'
            : icon === iconDone
            ? titleTrue
            : titleFalse;

    return (
        <div style={style}>
            {titleFalse && titleTrue ? <Tooltip title={title}>{icon}</Tooltip> : icon}
        </div>
    );
};

CellBoolean.propTypes = {
    value: PropTypes.bool.isRequired,
    titleTrue: PropTypes.string,
    titleFalse: PropTypes.string,
};

export default React.memo(CellBoolean);
